module.exports = 'ttb.issue.workLogDetails.workLogActivity.component';

angular.module(module.exports, [])
    .component('workLogActivity', {
        template: require('./work-log-activity.component.html'),
        bindings: {
            issueId: '<',
            teamId: '<',
            assignedTo: '<',
            workLogs: '<',
            activityLogId: '<',
            isProjectIterationBased: '<'
        },
        controller: WorkLogActivity
    });

function WorkLogActivity(workLogEditorService, $translate) {
    $translate.use(ttb.constants.cultureName)   
    this.$onInit = () => {
        if (DEBUG) {
            console.log(this);
        }
    };
    this.add = () => {
        workLogEditorService.addActivity({ issueId: this.issueId, teamId: this.teamId, isProjectIterationBased: this.isProjectIterationBased })
        /*    
        .then(res => {
                this.workLogs.push({
                    issueActivityLogId: res.id,
                    startDate: res.startTime,
                    endDate: res.endTime,
                    comment: res.comment,
                    duration: res.duration,
                    userWorkingConfig: res.userWorkingConfig,
                    assignedTo: res.assignedTo,
                    childDuration: res.childDuration,
                    activitySubItems: res.activitySubItems
                });
                
            })*/
            // closing the modal rejects the promise
            .catch(function() {});
    };
}
WorkLogActivity.$inject = ['workLogEditorService', '$translate'];


// WEBPACK FOOTER //
// ./components/work-log-activity/work-log-activity.component.js